import Layout from '@/layout/index.vue'
import { RouteConfig } from 'vue-router'

const DocumentsRouter: RouteConfig = {
  path: '/documents',
  component: Layout,
  meta: {
    roles: ['admin', 'operator'],
    // Добавляем проверку прав доступа к файловому менеджеру
    checkStorageAccess: true
  },
  children: [
    {
      path: 'index',
      component: () => import(/* webpackChunkName: "documents" */ '@/views/documents/index.vue'),
      name: 'Documents',
      meta: {
        title: 'Документы',
        icon: 'documentation',
        roles: ['admin', 'operator'],
        // Добавляем проверку прав доступа к файловому менеджеру
        // checkStorageAccess: true
      }
    }
  ]
}

export default DocumentsRouter 
